<template>
  <div class="new-dialer margin-left-alert">
    <div class="d-flex align-center new-dialer-intern px-2">
      <v-layout column>
        <v-flex xs12>
          <v-layout xs12 row mb-1 fill-height>
            <v-flex xs7 pt-2>
              <span class="white--text container-break">
                <b class="overflow-wrap-break-word">{{ $store.state.dialerV2.currentCall.full_name }}</b><span class="space-simulated">|</span><span class="other-text">{{ phone }}</span>
              </span>
              <div>
                <small class="white--text timer">
                  {{ timer }} <template v-if="$store.state.dialerV2.currentCall.type_id === 9">| <template v-if="$store.state.dialerV2.currentCall.original_channel_id === 4"><v-icon class="white--text mr-1 ml-1" small>fas fa-robot</v-icon> BOT</template><template v-else><v-icon class="white--text ml-1 mr-1" small>fas fa-phone fa-rotate-90</v-icon> IVR</template> - {{ $store.state.dialerV2.currentCall.ns_status }}</template>
                </small>
              </div>
            </v-flex>
            <v-flex column justify-end align-end xs5>
              <div class="text-xs-right h-100 flex-end">
                <!-- <v-tooltip bottom>
                  <v-btn color="k-white-linear" fab small disabled slot="activator" class="mr-1">
                    <v-icon color="white" v-if="true">
                      fas fa-circle
                    </v-icon>
                    <v-icon color="white" v-else>
                      fas fa-square
                    </v-icon>
                  </v-btn>
                  <span>No disponible por el momento</span>
                </v-tooltip> -->
                <v-btn color="k-blue-linear" fab small class="mr-1" @click="$store.dispatch('dialerV2/muteCall')">
                  <v-icon class="material-icons-outlined" size="20px" v-if="isMuted" color="white">
                    mic_off
                  </v-icon>
                  <v-icon class="material-icons-outlined" size="20px" v-else color="white">
                    mic_none
                  </v-icon>
                </v-btn>
                <v-btn fab small color="red" class="mx-0" @click="$store.dispatch('dialerV2/hangupCall')">
                  <v-icon class="material-icons-outlined" size="20px" color="white">
                    phone_disabled
                  </v-icon>
                </v-btn>
              </div>
            </v-flex>
          </V-layout>
        </v-flex>
      </v-layout>
    </div>
    <div v-if="showWarningTime" :class="{ 'overlay-1': true, 'width-warning-large': isWarningTimerLarge, 'width-warning-medium': !isWarningTimerLarge }">
      <small class="black--text timer-text">
        <v-icon class="rotating-clock" size="24px" color="black">timer</v-icon> <b>{{ warningTime }}</b>
      </small>
    </div>
    <div v-else-if="showAlertTime" :class="{ 'overlay-2': true ,'height-alert-large': soundIsRunning, 'height-alert-medium': !soundIsRunning }">
        <div class="w-100">
          <small class="white--text">
            <v-icon class="rotating-clock" size="15px" color="white">timer</v-icon> {{ textAlertHuman }}
          </small>
        </div>
         <div v-if="soundIsRunning" class="w-100">
           <v-btn block small color="white" class="red--text btn-alert" @click="endSound()">
             <v-icon class="material-icons" size="20px" color="red">
               notifications_active
             </v-icon><span class="space-simulated">Desactivar alarma</span>
           </v-btn>
         </div>
      </div>
  </div>
</template>

<script>
import callTimeAndAlertMixin from '@/mixins/callTimeAndAlert';
import permissionsMixin from '@/mixins/permissions';

export default {
  mixins: [
    permissionsMixin,
    callTimeAndAlertMixin,
  ],
  computed: {
    isWarningTimerLarge() {
      return this.warningTime.length >= 8;
    },
    isMuted() {
      const softPhone = this.$store.state.dialerV2.softPhone;
      if (softPhone) {
        return softPhone.isMuted();
      }

      return this.$store.state.dialerV2.audioTrack.isMuted;
    },
    phone() {
      let phone = this.$store.state.dialerV2.currentCall.phone;
      if (!this.canSeeMasked && !phone.includes('*')) {
        const length = phone.length - 3;
        const chars = '*'.repeat(length);
        phone = `${chars}${phone.slice(-3)}`;
      }
      return phone;
    },
    canSeeMasked() {
      return this.checkPermissions([
        'see_masked_data',
      ]); 
    },
    currentCallId() {
      return this.$store.state.dialerV2.currentCall.call_id;
    }
  },
};
</script>

<style scoped>
.width-warning-large {
  width: 509px !important;
}

.width-warning-medium {
  width: 489px !important;
}
.height-alert-large {
  height: 229% !important;
}

.height-alert-medium {
  height: 156% !important;
}
.flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}

.container-break {
  max-width: 208px !important;
  display: flex;
    align-items: center;
}
.other-text {
  word-break: normal !important;
}
.overflow-wrap-break-word{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rotating-clock {
  margin-right: 0.1rem;
  animation: rotateAnimation 1s ease-in-out infinite;
}

@keyframes rotateAnimation {
  0%, 100% {
    transform-origin: center center;
    transform: rotate(-20deg);
  }
  50% {
    transform-origin: center center;
    transform: rotate(20deg);
  }
}
.new-dialer {
  position: relative;
  border-radius: 8px;
}

.new-dialer-intern {
  background-color: #88929F;
  position: relative;
  border-radius: 6px; 
  max-width: 401px;
  min-width: 401px;
  z-index: 53;
} 

@keyframes colorAnimation {
  0%, 100% {
    background-color: #FFD939;
  }
  50% {
    background-color: #ffe371;
  }
}

.overlay-1 {
  position: absolute;
  right: -1px;
  top: -1px;
  background-color: #FFD939;
  border-radius: 6px;
  width: 509px;
  height: 104%;
  padding-left: 1rem;
  margin-left: -1rem;
  display: flex;
  flex-direction: row;
  z-index: 1;
  animation: colorAnimation 1s ease-in-out infinite;
  transform-origin: right center;
  animation: appearFromRight 0.5s ease-out;
}
.overlay-2 {
  position: absolute;
  right: -1px;
  top: -1px;
  background-color: #F44336;
  border-radius: 6px;
  width: 404px;
  height: 225%;
  padding-left: 1rem;
  padding-bottom: 0.5rem;
  margin-left: -1rem;
  display: flex;
  flex-direction: column;
  z-index: 52;
  transform-origin: top center;
  animation: appearFromTop 0.5s ease-out;
}

.overlay-2 div:first-child {
  margin-top: auto;
}

.overlay-2 div:last-child {
  padding-right: 1rem !important;
}

.btn-alert {
  text-transform: none !important;
  border-radius: 5px !important;
}
.margin-left-alert {
  margin-left: 98px;
}

.overlay-2 > small {
  position: relative;
  align-self: flex-end;
  z-index: 3000;
}
.overlay-1 > small {
  position: relative;
  align-self: center;
  z-index: 3000;
}

.timer-text {
  font-size: 15px!important;
  display: flex;
  align-items: center;
}
.timer i {
  font-size: 10px !important;
}
.text-truncate {
  width: 160px !important;
}
.clock{
  display: flex; 
  flex-direction: column; 
  justify-content: flex-end;

}
.space-simulated {
  padding: 0 1em 0 1em;
}

@keyframes appearFromRight {
  from {
    width: 406px;
  }
  to {
    width: 489px;
  }
}
@keyframes appearFromTop {
  from {
    height: 106px;
  }
  to {
    height: 139px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CallCenter/DialerV2.vue